import { useCallback, useEffect, useRef, useState } from "react";

export function useAsync<T>(fn: () => Promise<T>, deps: unknown[] = []) {
  const [data, setData] = useState<T | undefined>();
  const [error, setError] = useState<string | undefined>();
  const [loading, setLoading] = useState(true);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const run = useCallback(fn, deps);
  // Only the latest load counts: a slower earlier one must not overwrite it (from-testing #46).
  const seq = useRef(0);

  const reload = useCallback(() => {
    const mine = ++seq.current;
    setLoading(true);
    setError(undefined);
    run()
      .then((d) => {
        if (mine === seq.current) setData(d);
      })
      .catch((e: unknown) => {
        if (mine === seq.current) setError(errorMessage(e));
      })
      .finally(() => {
        if (mine === seq.current) setLoading(false);
      });
  }, [run]);

  useEffect(reload, [reload]);
  return { data, error, loading, reload };
}

export function errorMessage(e: unknown): string {
  if (e instanceof Error) return e.message;
  if (e && typeof e === "object" && "message" in e && typeof (e as { message: unknown }).message === "string") {
    return (e as { message: string }).message;
  }
  return String(e);
}

export { aud, fmtDate } from "./format";
